import React, { useState, useEffect } from 'react';

const Reaction = ({ id }) => {
    const [reaction, setReaction] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const savedReaction = localStorage.getItem(`reaction_${id}`);
        setReaction(savedReaction || null);
    }, [id]);

    const postReaction = async (type) => {
        if (loading) return;
        setLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API}reactions`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ articleId: id, type: type }),
            });

            const data = await response.json();
            if (response.ok) {
                if (data.status === 'removed') {
                    setReaction(null);
                    localStorage.removeItem(`reaction_${id}`);
                } else {
                    setReaction(type);
                    localStorage.setItem(`reaction_${id}`, type);
                }
            }
        } catch (error) {
            console.error("Gagal mengirim penilaian:", error);
            alert("Terjadi kesalahan, coba lagi nanti.");
        } finally {
            setLoading(false);
        }
    };

    // Fungsi helper untuk menentukan class tombol berdasarkan status reaction
    const getButtonClass = (type) => {
        const baseClass = "flex items-center justify-center px-6 py-2 border rounded-lg text-sm font-medium transition-all duration-200";
        const activeClass = reaction === type 
            ? "border-[#F36F21] bg-[#FFF1E6] text-[#F36F21]" 
            : "border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50";
        return `${baseClass} ${activeClass}`;
    };

    return null
    return (
        <div className="p-6 md:p-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
            
            {/* Bagian Teks */}
            <div className="text-left">
                <h4 className="text-base md:text-lg font-bold text-[#101828] mb-1">
                    Apakah ini menjawab pertanyaan Anda?
                </h4>
                <p className="text-sm text-[#475467]">
                    Penilaian ini dapat membantu kami meningkatkan kualitas artikel ini
                </p>
            </div>

            {/* Bagian Tombol */}
            <div className="flex items-center gap-3">
                <button 
                    disabled={loading}
                    onClick={() => postReaction('yes')}
                    className={getButtonClass('yes')}
                >
                    <img 
                        src={`${process.env.REACT_APP_S3}thumb_up.png`} 
                        alt="Ya" 
                        className="w-5 h-5 mr-2 object-contain" 
                    />
                    Ya
                </button>

                <button 
                    disabled={loading}
                    onClick={() => postReaction('no')}
                    className={getButtonClass('no')}
                >
                    <img 
                        src={`${process.env.REACT_APP_S3}thumb_down.png`} 
                        alt="Tidak" 
                        className="w-5 h-5 mr-2 object-contain" 
                    />
                    Tidak
                </button>
            </div>
        </div>
    );
};

export default Reaction;